
export function translateKey (input) {
  switch (input) {
    case 'Control':
      return 'Ctrl'
    case 'Return':
      return '⏎'
    default:
      return input
  }
}

export function translateKeys (keys) {
  return keys.map(translateKey)
}

export function describeHotKey (named) {
  switch (named) {
    case 'not known':
      return ''
    case 'interrupt':
      return 'copy to clipboard or interrupt a process'
    case 'switch window':
      if (this.keyCombo.includes('Ctrl')) {
        return 'switch tab'
      }
      break
  }
  return named
}